import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, from, mergeMap, of, switchMap, withLatestFrom } from 'rxjs'
import { applicationSlice } from '../../Slice/Application/ApplicationSlice.js'
import { ProjectLockedBlocker, ProjectLockedBlockerId } from './HandleProjectLockChangedEpic.js'
import { isNotFoundError } from '../../../View/Component/scopeNotFound.ts'

export const GetProjectEpic: Epic = (
  action$,
  state$,
  { [projectSlice.name]: project, [applicationSlice.name]: application, ProjectRepository }
) =>
  action$.pipe(
    filter(project.getProjectRequest.match),
    withLatestFrom(state$),
    // The store holds one project: an answer for a project asked about before the latest must not land.
    switchMap(([action]) => {
      return ProjectRepository.getProject(action.payload.projectId).pipe(
        mergeMap((response) => {
          if (response.lock) {
            return from([project.getProjectRequestSuccess(response), application.addBlockingRequest(ProjectLockedBlocker(response.id))])
          } else {
            return from([
              project.getProjectRequestSuccess(response),
              application.removeBlockingRequest(ProjectLockedBlockerId(response.id))
            ])
          }
        }),
        catchError((error) =>
          of(project.getProjectRequestFailure({ error, projectId: action.payload.projectId, notFound: isNotFoundError(error) }))
        )
      )
    })
  )
